type ZendeskUrlType = keyof typeof Main;

const RequestFormId = {
  AccountDeletion: '6046826672911',
  GeneralFeedbackEnquiry: '4412737459215',
  EventsAndBonus: '7319571009423',
  AccountRegistration: '7319587952783',
  AccountManagement: '7319609585807',
  IdentityVerification: '7319600470543',
  WalletAsset: '7319580457487',
  Trade: '7319618145295',
  BusinessPartnership: '7319605125903',
  AffiliateProgram: '7319698703503',
} as const;

const Main = {
  Domain: 'https://support.flipster.io',
  DomainOriginal: 'https://aqx.zendesk.com',
  EmergenciesApi: '/api/v2/help_center/en-us/articles.json?label_names=important&page[size]=1',
  NoticesApi: '/api/v2/help_center/en-us/sections/7351723129231/articles.json?per_page=5',
  RequestNew: '/hc/en-us/requests/new',
  Promotion: '/hc/en-us/categories/7418415093007-Promotions',
  PromotionRankings: '/hc/en-us/sections/7460153406863-Promotion-Rankings',
  Faqs: '/hc/en-us/sections/7351723157903-General-FAQ',
  Notice: '/hc/en-us/sections/7351723129231-Updates-Announcements',
  RestrictedCountries: '/hc/en-us/articles/7377472797967-Flipster-Country-Restrictions',
  ReferralProgram: '/hc/en-us/articles/9583312910863-Flipster-Referral-Program-240501',
  RewardsHubProgram: '/hc/en-us/articles/10061160327823-Rewards-Hub-Program-240628',
  DailyReward: '/hc/en-us/articles/8951036743311-Daily-Check-in-Random-Reward-Program-240213-Completed',
  KycFaqs: '/hc/en-us/articles/7360996655503-Identity-Verification-FAQ',
  VipProgram: '/hc/en-us/articles/9932960817551-Flipster-VIP-Program-240617',
  EarnCampaign: '/hc/en-us/articles/9371008401551-Flipster-Earn-Campaign-240403',
  USDeEarnTerms: '/hc/en-us/articles/14104482806415-USDe-Earn',
  BonusExplained: '/hc/en-us/articles/7353403192463-Bonus-Explained',
  TradingPause: '/hc/en-us/articles/10105223131151-Trade-Pause-FAQ',
  SparkRewardProgram: '/hc/en-us/articles/10625851420047-Spark-Rewards-Program-240912',
  InstallationFlipsterApk: '/', // support.flipster.io 에는 게시물 없음
  FlashPositionAirdropProgram: '/', // 업데이트 예정 https://prextech.slack.com/archives/C07BK9M6SLA/p1727315976851869?thread_ts=1727312407.961299&cid=C07BK9M6SLA
  IdentityVerificationUpdates:
    '/hc/en-us/articles/10822322825615-Important-Identity-Verification-Updates-24-October-2024',
  AffiliateProgramTerms: '/hc/en-us/articles/9660062891151-Affiliate-Program-Terms-20240502',
  AffiliateProgramPrivacyPolicy: '/hc/en-us/articles/9659742577423-Affiliate-Program-Privacy-Policy-20240502',
  MasterLeagueLeaderboard: '/hc/en-us/articles/11319235194511-Master-League-Leaderboard-241128',
  MigrationOfInternationalUsers: '/hc/en-us/articles/11438094062223-Migration-of-International-Users-to-Flipster-Corp',
  Vip1YearAnniversary:
    '/hc/en-us/articles/11436480613647-VIP-Program-1-Year-Anniversary-Master-League-P-L-Competition-241223',
  HowToVerifyYourFlipsterAccount: '/hc/en-us/articles/7352136981775-How-to-Verify-your-Flipster-Account',
  Withdrawal: '/hc/en-us/articles/7353457921679-Withdrawal',
  WithdrawalFaq: '/hc/en-us/articles/7361330119823-Withdrawal-FAQ',
} as const;

const Sub = {
  Domain: 'https://support.flipster.me',
  DomainOriginal: 'https://aqx.zendesk.com',
  EmergenciesApi: '/api/v2/help_center/en-us/articles.json?label_names=important&page[size]=1',
  NoticesApi: '/api/v2/help_center/en-us/sections/10452338464783/articles.json?per_page=5',
  RequestNew: '/hc/en-us/requests/new',
  Promotion: '/hc/en-us/categories/10452315934607-Promotions',
  PromotionRankings: '/hc/en-us/sections/10452332582799-Promotion-Rankings',
  Faqs: '/hc/en-us/sections/10452341275151-General-FAQ',
  Notice: '/hc/en-us/sections/10452338464783-Updates-Announcements',
  RestrictedCountries: '/hc/en-us/articles/10454626217103-Flipster-Country-Restrictions',
  ReferralProgram: '/hc/en-us/articles/10454750584975-Flipster-Referral-Program-240501',
  RewardsHubProgram: '/hc/en-us/articles/10454760231183-Rewards-Hub-Program-240628',
  DailyReward: 'hc/en-us/articles/10454764985743-Daily-Check-in-Random-Reward-Program-240213-Completed',
  KycFaqs: '/hc/en-us/articles/10454752888847-Identity-Verification-FAQ',
  VipProgram: '/hc/en-us/articles/10454765404943-Flipster-VIP-Program-240617',
  EarnCampaign: '/hc/en-us/articles/10454765171471-Flipster-Earn-Campaign-240403',
  USDeEarnTerms: '/hc/en-us/articles/14104490766607-USDe-Earn',
  BonusExplained: '/hc/en-us/articles/10454674869391-Bonus-Explained',
  TradingPause: '/hc/en-us/articles/10454798081935-Trade-Pause-FAQ',
  SparkRewardProgram: '/hc/en-us/articles/10709502977551-Spark-Rewards-Program-240912',
  InstallationFlipsterApk: '/hc/en-us/articles/10711919264911-Installing-Flipster-APK-on-Android-Device',
  FlashPositionAirdropProgram: '/', // 업데이트 예정 https://prextech.slack.com/archives/C07BK9M6SLA/p1727315976851869?thread_ts=1727312407.961299&cid=C07BK9M6SLA
  IdentityVerificationUpdates:
    '/hc/en-us/articles/11029076728079-Important-Identity-Verification-Updates-24-October-2024',
  AffiliateProgramTerms: '/hc/en-us/articles/9660062891151-Affiliate-Program-Terms-20240502',
  AffiliateProgramPrivacyPolicy: '/hc/en-us/articles/9659742577423-Affiliate-Program-Privacy-Policy-20240502',
  MasterLeagueLeaderboard: '/hc/en-us/articles/11319612424591-Master-League-Leaderboard-241128',
  MigrationOfInternationalUsers: '/hc/en-us/articles/11494533454223-Migration-of-International-Users-to-Flipster-Corp',
  Vip1YearAnniversary:
    '/hc/en-us/articles/11461752572559-VIP-Program-1-Year-Anniversary-Master-League-P-L-Competition-241223',
  HowToVerifyYourFlipsterAccount: '/hc/en-us/articles/10454619751567-How-to-Verify-your-Flipster-Account',
  Withdrawal: '/hc/en-us/articles/10454645543311-Withdrawal',
  WithdrawalFaq: '/hc/en-us/articles/10454785197455-Withdrawal-FAQ',
} as const satisfies Record<ZendeskUrlType, string>;

const ZendeskPathMapper = { Main, Sub };

class Zendesk {
  #domainType: 'Main' | 'Sub' = 'Main';

  setEnv(path: string | undefined) {
    if (path?.includes('flipster.me')) this.#domainType = 'Sub';
  }

  get domain() {
    return ZendeskPathMapper[this.#domainType]['Domain'];
  }

  get originalDomain() {
    return ZendeskPathMapper[this.#domainType]['DomainOriginal'];
  }

  // Returns the domain that is used to directly access Zendesk
  getZendeskExternalUrl(type: ZendeskUrlType, params: Record<string, string> = {}) {
    const queryString = new URLSearchParams(params).toString();
    return `${this.domain}${ZendeskPathMapper[this.#domainType][type]}${queryString ? `?${queryString}` : ''}`;
  }

  // Returns the domain that is used to bridge to Zendesk
  getUrl(type: ZendeskUrlType, { ticketForm }: { ticketForm?: keyof typeof RequestFormId } = {}) {
    if (type === 'Domain') return this.domain;

    const params: Record<string, string> = {};

    if (type === 'RequestNew' && ticketForm) {
      params.ticket_form_id = RequestFormId[ticketForm];
    }

    let zendeskUrl = this.getZendeskExternalUrl(type, params);

    return `/support/zendesk/?zendesk_url=${zendeskUrl}`;
  }

  redirectToZendeskLogin(jwt: string, returnTo: string) {
    // JWT access is only available on the original domain
    window.location.replace(`${this.originalDomain}/access/jwt/?jwt=${jwt}&return_to=${returnTo}`);
  }
}

export const zendesk = new Zendesk();
